import "./home.scss";
import { useQuery } from '@tanstack/react-query';
import Button from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { getCompanies } from '../../api/hub.service';
import { useAuth } from '../../contexts/auth';

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const companies = useQuery({ queryKey: ['companies'], queryFn: getCompanies });

  return (
    <div className="page-body hub-home">
      <section className="home-hero">
        <div>
          <span className="hub-eyebrow">Central de integrações</span>
          <h2>Olá, {user?.email?.split('@')[0] ?? 'operador'}.</h2>
          <p>Gerencie o catálogo de empresas e as credenciais dos provedores a partir de uma visão central e segura.</p>
        </div>
        <Button text="Consultar empresas" icon="group" type="default" onClick={() => navigate('/companies')} />
      </section>

      <section className="home-metrics" aria-label="Resumo do ambiente">
        <article className="home-metric">
          <span>Empresas disponíveis</span>
          <strong>{companies.isLoading ? '…' : (companies.data?.length ?? 0).toLocaleString('pt-BR')}</strong>
          <small>Catálogo ao vivo do PresenceTenant</small>
        </article>
        <article className="home-metric">
          <span>Cadastro oficial</span>
          <strong>Tenant</strong>
          <small>Sem espelho local de empresas</small>
        </article>
        <article className="home-metric">
          <span>Provedor disponível</span>
          <strong>ElosGate</strong>
          <small>Credenciais segregadas por empresa e loja</small>
        </article>
      </section>

      <section className="home-workspace">
        <div className="home-section-heading">
          <div>
            <span className="hub-eyebrow">Acesso rápido</span>
            <h3>Espaço de trabalho</h3>
          </div>
          <p>As operações mais frequentes do ambiente administrativo.</p>
        </div>
        <div className="home-action-grid">
          <button type="button" className="home-action-card" onClick={() => navigate('/companies')}>
            <span className="home-action-icon dx-icon-group" aria-hidden="true" />
            <span><strong>Empresas e lojas</strong><small>Consulte o cadastro oficial e as lojas controladas.</small></span>
            <span className="dx-icon-chevronright" aria-hidden="true" />
          </button>
          <button type="button" className="home-action-card" onClick={() => navigate('/provider-accounts')}>
            <span className="home-action-icon dx-icon-card" aria-hidden="true" />
            <span><strong>Contas ElosGate</strong><small>Configure endpoints, chaves e abrangência por loja.</small></span>
            <span className="dx-icon-chevronright" aria-hidden="true" />
          </button>
        </div>
      </section>
    </div>
  );
}
